import { ROUTES } from 'configs';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { commonSetStorageCommunity } from 'utils/commonStorage';

type UseSchedulerHashRoutingOptions = {
  enabled: boolean;
  setActiveTab: (index: number) => void;
};

/** Hash / path sync for group and overall scheduler tabs. */
export const useSchedulerHashRouting = ({
  enabled,
  setActiveTab,
}: UseSchedulerHashRoutingOptions) => {
  const { groupId, communityId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const { hash } = window.location;

    if (hash === '#notifications') {
      setActiveTab(1);
    } else if (hash === '#members') {
      setActiveTab(5);
    } else if (hash === '#requests') {
      setActiveTab(6);
    } else if (hash === '#event-types') {
      setActiveTab(2);
    } else if (hash === '#scheduler') {
      setActiveTab(0);
    } else if (hash === '#matrix') {
      setActiveTab(1);
    }
  }, [enabled, setActiveTab]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const { hash, pathname } = window.location;

    if (hash === '#statistics' || hash === '#memberPresence') {
      setActiveTab(4);
    }

    if (pathname.includes('overall') && hash === '') {
      setActiveTab(0);
    }

    if (pathname.includes('overall') && hash === '#members') {
      setActiveTab(2);
    }

    if (hash === '#import') {
      if (groupId) {
        commonSetStorageCommunity(`${ROUTES.COMMUNITY}/${communityId}/overall`);
        navigate(`${ROUTES.COMMUNITY}/${communityId}/overall/#import`, {
          replace: true,
        });
      }
      setActiveTab(1);
    }
  }, [communityId, enabled, groupId, navigate, setActiveTab]);
};
